import {ConversationResource, MessageBoxResource} from "../Api/Inbox";
import {TagResource} from "../Api/Tag";

const messageBoxes = {
    namespaced: true,
    state: {
        message_boxes: [],
        loaded: false,
    },
    mutations: {
        set(state, payload) {
            state.message_boxes = payload
            state.loaded = true
        }
    },
    getters: {
        loaded(state) {
            return state.loaded
        },
        first(state) {
            if (state.message_boxes.length > 0) {
                return state.message_boxes[0]
            }
        },
        all(state) {
            return state.message_boxes
        },
        find: (state) => (id) => {
            return state.message_boxes.find(i => i.id === id)
        },
        users(state) {
            let users = []

            for (let i in state.message_boxes) {
                for (let j in state.message_boxes[i].users) {
                    let user = state.message_boxes[i].users[j]
                    if (!users.find(u => u.id === user.id)) {
                        users.push(user)
                    }
                }
            }

            return users
        }
    },
    actions: {
        getOrLoad(context) {
            return new Promise((resolve, reject) => {
                if (context.state.message_boxes.length > 0) {
                    resolve(context.state.message_boxes)
                }

                context.dispatch('load').then(resolve)
            })
        },
        load(context) {
            return new Promise((resolve, reject) => {
                MessageBoxResource.all({ with: ['users'] }).then(r => {
                    context.commit('set', r.data)
                    resolve(r.data)
                }).catch(e => handleApiError(e, reject))
            })
        },
    }
}

const conversations = {
    namespaced: true,
    state: {
        conversation: {},
    },
    mutations: {
        set(state, payload) {
            state.conversation = payload
        },
        incrementMessageEventCount(state, { id, type}) {
            for (let i in state.conversation.chronology) {
                for (let j in state.conversation.chronology[i]) {
                    if (state.conversation.chronology[i][j].id === id && state.conversation.chronology[i][j].chronology_item_type === 'message') {
                        state.conversation.chronology[i][j].events[type]++
                    }
                }
            }
        }
    },
    getters: {
        conversation(state) {
            return state.conversation
        }
    },
    actions: {
        load(context, {conversation_id}) {
            context.commit('set', {})

            return new Promise((resolve, reject) => {
               ConversationResource.find(conversation_id).then(r => {
                    context.commit('set', r.data.data)
                    resolve(r.data)
                }).catch(reject)
            })
        },
        reload(context) {
            return new Promise((resolve, reject) => {
               ConversationResource.find(context.state.conversation.id).then(r => {
                    context.commit('set', r.data.data)
                    resolve(r.data)
                }).catch(reject)
            })
        },
        assign(context, {conversation_id, user_id}) {
            return new Promise((resolve, reject) => {
               ConversationResource.assignUser(conversation_id, user_id).then(r => {
                    context.dispatch('reload').then(resolve)
                }).catch(e => handleApiError(e, reject))
            })
        },
        unassign(context, {conversation_id, user_id}) {
            return new Promise((resolve, reject) => {
               ConversationResource.unassignUser(conversation_id, user_id).then(r => {
                    context.dispatch('reload').then(resolve)
                }).catch(e => handleApiError(e, reject))
            })
        },
        unassignAll(context, {conversation_id}) {
            return new Promise((resolve, reject) => {
               ConversationResource.unassignAll(conversation_id).then(r => {
                    context.dispatch('reload').then(resolve)
                }).catch(e => handleApiError(e, reject))
            })
        },
        tag(context, {conversation_id, tag}) {
            return new Promise((resolve, reject) => {
              TagResource.attach(tag, 'inbox.conversation:' + conversation_id).then(r => {
                    context.dispatch('reload').then(resolve)
                }).catch(e => handleApiError(e, reject))
            })
        },
        untag(context, {conversation_id, tag}) {
            return new Promise((resolve, reject) => {
              TagResource.detach(tag, 'inbox.conversation:' + conversation_id).then(r => {
                    context.dispatch('reload').then(resolve)
                }).catch(e => handleApiError(e, reject))
            })
        },
        status(context, {conversation_id, status}) {
            return new Promise((resolve, reject) => {
               ConversationResource.status(conversation_id, status).then(r => {
                    context.dispatch('reload').then(resolve)
                }).catch(e => handleApiError(e, reject))
            })
        },
        transfer(context, {conversation_id, message_box_id}) {
            return new Promise((resolve, reject) => {
               ConversationResource.transfer(conversation_id, message_box_id).then(r => {
                    context.dispatch('reload').then(resolve)
                }).catch(e => handleApiError(e, reject))
            })
        }
    }
}

const tags = {
    namespaced: true,
    state: {
        tags: {},
    },
    mutations: {
        set(state, payload) {
            state.tags = payload
        }
    },
    getters: {
        tags(state) {
            return state.tags
        }
    },
    actions: {
        load(context) {
            return new Promise((resolve, reject) => {
                TagResource.all().then(r => {
                    context.commit('set', r.data)
                    resolve()
                }).catch(e => handleApiError(e, reject))
            })
        }
    }
}

const Inbox = {
    namespaced: true,
    modules: { messageBoxes, conversations, tags }
}

export default Inbox